import { render, staticRenderFns } from "./reading-pen.vue?vue&type=template&id=4f9b4310&lang=pug&"
import script from "./reading-pen.vue?vue&type=script&lang=js&"
export * from "./reading-pen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports